export default {
  state: {
    customerInfo: {
      companyName: '',
      postalCode: '',
      streetAddress: '',
      representativeName: '',
      personInCharge: '',
      phoneNumber: '',
      email: '',
      buildingName: ''
    }
  },
  getters: {
    getCustomerInfo (state) {
      return state.customerInfo
    }
  },
  mutations: {
    SET_CUSTOMER_INFO (state, payload) {
      state.customerInfo = {...payload}
    },
    CLEAR_DATA (state) {
      state.customerInfo = {
        companyName: '',
        postalCode: '',
        streetAddress: '',
        representativeName: '',
        personInCharge: '',
        phoneNumber: '',
        email: '',
        buildingName: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/paidPlansStore.js